import  gql  from 'graphql-tag'

export const CREATE_FINANCIAL_OBLIGATION_TYPE = gql`mutation financialObligationTypes($input: FinancialObligationTypesMutationInput!){
    financialObligationType(input: $input){
        financialObligationTypes{
            id
            code
            name
            isActive
        }
        errors{
            field
            messages
        }
    }
}`;